import { render, staticRenderFns } from "./placeModalUpdate.vue?vue&type=template&id=64309e58&scoped=true&"
import script from "./placeModalUpdate.vue?vue&type=script&lang=js&"
export * from "./placeModalUpdate.vue?vue&type=script&lang=js&"
import style0 from "./placeModalUpdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./placeModalUpdate.vue?vue&type=style&index=1&id=64309e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64309e58",
  null
  
)

export default component.exports